import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutGrid, Trophy, Swords, Users, User } from "lucide-react";

const items = [
  { to: "/skate/dashboard",   icon: LayoutGrid, label: "HOME",  testid: "nav-home" },
  { to: "/skate/leaderboard", icon: Trophy,     label: "RANKS", testid: "nav-leaderboard" },
  { to: "/skate/challenges",  icon: Swords,     label: "BATTLE",testid: "nav-challenges" },
  { to: "/skate/scene",       icon: Users,      label: "SCENE", testid: "nav-scene" },
  { to: "/skate/profile",     icon: User,       label: "ME",    testid: "nav-profile" },
];

export const BottomNav = () => {
  const { pathname } = useLocation();
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 border-t border-zinc-800 bg-black/85 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-2xl mx-auto grid grid-cols-5">
        {items.map(({ to, icon: Icon, label, testid }) => {
          const active = pathname.startsWith(to);
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className="relative flex flex-col items-center justify-center gap-1 py-3 transition-colors"
            >
              <Icon className={`w-5 h-5 ${active ? "text-[#FACC15]" : "text-zinc-500"}`} strokeWidth={1.8} />
              <span className={`font-display text-[10px] tracking-[0.18em] ${active ? "text-white" : "text-zinc-500"}`}>
                {label}
              </span>
              {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-px bg-[#FACC15]" />}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
